import { ActionType } from "../types/Actions";

type ActionDefinitionDefaults = {
    name: string;
    title: string;
};

const ACTION_TYPE_PREFIX_REGEX = /^(Attachment|Client|Flow|Task):\s*/i;

const ACTION_TYPE_DEFAULTS: Record<string, ActionDefinitionDefaults> = {
    UploadAndAnalyzeInAI: {
        title: "Upload and Analyze in AI",
        name: "upload_and_analyze_in_ai",
    },
    ViewAiSession: {
        title: "View AI session",
        name: "view_ai_session",
    },
    OpenLink: {
        title: "Open link",
        name: "open_link",
    },
    ExecuteWorkflow: {
        title: "Run workflow",
        name: "run_workflow",
    },
    SendWorkflowSignal: {
        title: "Notify instance",
        name: "notify_instance",
    },
    RestCall: {
        title: "Send request",
        name: "send_request",
    },
};

const toSystemName = (value: string) =>
    value
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "_")
        .replace(/^_+|_+$/g, "");

const getFallbackTitle = (actionType: Pick<ActionType, "title">) => {
    const sanitizedTitle = actionType.title
        .replace(ACTION_TYPE_PREFIX_REGEX, "")
        .trim();

    return sanitizedTitle || actionType.title;
};

export const getActionDefinitionDefaults = (
    actionType?: Pick<ActionType, "name" | "title">,
): ActionDefinitionDefaults | undefined => {
    if (!actionType) {
        return undefined;
    }

    const explicitDefaults = ACTION_TYPE_DEFAULTS[actionType.name];
    if (explicitDefaults) {
        return explicitDefaults;
    }

    const fallbackTitle = getFallbackTitle(actionType);
    const fallbackName =
        toSystemName(fallbackTitle) || toSystemName(actionType.name);

    return {
        title: fallbackTitle,
        name: fallbackName,
    };
};
